import { render } from "./Shifts.vue?vue&type=template&id=3dbadede"
import script from "./Shifts.vue?vue&type=script&lang=js"
export * from "./Shifts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/thadmin/thadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__